import Route from '@ember/routing/route';

export default class EntriesTeamsRoute extends Route 
{
	model() 
	{
		return this.modelFor("event");
	}
}
